import { IS_LOADING_POST_HOME_PROFESSIONAL, GET_POST_HOME_PROFESSIONAL, IS_LOADING_POST_HOME, GET_POST_HOME, ADD_POST_HOME, ADD_POST_HOME_CAMPAIGN } from './types'
import { urlServer } from '../config/GlobalConstant'
import inMemoryJWT from '../auth/inMemoryJwt';
import localStorage from '../utils/hooks/useLocalStorage';
//get post of home
export const getPostHome = (page,getCampaing) => async dispatch => {

    dispatch({
        type: IS_LOADING_POST_HOME
    });

    await fetch(`${urlServer}posts/home`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            limit: 14,
            skip: page
        })
    })
        .then(response => response.json())
        .then(respJson => {

            if (respJson.data.length > 0) {
                dispatch({
                    type: GET_POST_HOME,
                    payload: { data: respJson.data, page, hasMore: true }
                });
                
            }
            else {
                dispatch({
                    type: GET_POST_HOME,
                    payload: { data: [], page, hasMore: false }
                });
            }
            if(page==0){
                getCampaing()
            }
           
        })
        .catch(error => {
            console.log()
        })
}
export const getCampaingActive = () => async dispatch => {

   

    await fetch(`${urlServer}admincampaigns/get-active`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }
    })
        .then(response => response.json())
        .then(respJson => {
            const data = respJson.data

            dispatch({
                type: ADD_POST_HOME_CAMPAIGN ,
                payload:{
                    multimedia:data.multimedia,
                    description:data.description,
                    type:"postCampaing"
                }
            })
        })
        .catch(error => {
            console.log()
        })
}


export const getPostProfessionalHome = () => async dispatch => {

    await fetch(`${urlServer}api/professionalpost/home`, {

        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            entityID: localStorage().getItem('professionalID')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({
                type: IS_LOADING_POST_HOME_PROFESSIONAL
            });
            console.log()
            console.log()
            dispatch({
                type: GET_POST_HOME_PROFESSIONAL,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })

}